import { render, staticRenderFns } from "./aiPhoto.vue?vue&type=template&id=8c8aa854&scoped=true&"
import script from "./aiPhoto.vue?vue&type=script&lang=js&"
export * from "./aiPhoto.vue?vue&type=script&lang=js&"
import style0 from "./aiPhoto.vue?vue&type=style&index=0&id=8c8aa854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8aa854",
  null
  
)

export default component.exports